module.exports = __webpack_public_path__ + "img/1.1dd70ca2.png";